(function (Backbone, EG, $) {
  'use strict';

  function parsePersonalInfo(options) {
    var templateData, templateConfig, isSaveDisable, config, phones, addresses, titles, countries, personalInfo;

    templateData = {};

    isSaveDisable = true;
    templateConfig = options.config || {};
    personalInfo = options.personalInfo || {};
    titles = options.titles || [];
    countries = options.countries || [];
    phones = options.phones || [];
    addresses = options.addressess || [];

    return templateData;

    userDefaultAddress = addresses.getDefaultAddress();

    templateData.addressExistsInProfile = addresses.doesAddressExist();

    if (templateData.addressExistsInProfile) {
      countries.setDefaultCountry(userDefaultAddress.getCountryCode());
    }

    // Prepare template data in templateData to be passed to template config for view.
    templateData.info = personalInfoResponse.toJSON();
    templateData.titles = title.toJSON();
    templateData.countries = countries.toJSON();
    templateData.UserAddresses = templateData.addressExistsInProfile ? userDefaultAddress.toJSON() : {};
    templateData.disableSaveProfile = false;
    templateData.costCenter3 = getCostCenter3();

    _shouldMaskDOB = shouldMaskDOB() && templateData.info.date_of_birth;

    if (_shouldMaskDOB) {
      templateData.info.date_of_birth = undefined;
    }

    templateData.phones = {};
    _.each(phones.toJSON(true), function (phoneObj) {
      var phoneType;

      phoneType = EG.Users.Utils.getPhoneType(phoneObj.type_code);

      templateData.phones[phoneType] = phoneObj;
    });

    function markReadOnlyRecurse(config) {
      _.each(config, function (value, key) {
        if (_.isObject(value)) {
          markReadOnlyRecurse(value, config);
        } else {
          if (config.enabled) {
            config.readonly = true;
          }
        }
      });
    }

    function markReadOnly(config) {
      var tempConfig = EG.Users.Utils.deepCloneObject(config);
      markReadOnlyRecurse(tempConfig);
      return tempConfig;
    }

    function shouldSaveProfileRecurse(config) {
      _.each(config, function (value, key) {
        if (_.isObject(value) && value.enabled) {
          shouldSaveProfileRecurse(value);
        } else {
          if (!isSaveDisable || config.readonly == false || (config.enabled && config.readonly != true)) {
            isSaveDisable = false;
            return;
          }
        }
      });
    }

    function shouldSaveProfile(config) {
      shouldSaveProfileRecurse(config.personal_info);
      if (isSaveDisable) {
        templateData.disableSaveProfile = true;
      }
    }
    shouldSaveProfile(templateConfig);

    if (personalInfo.isDeleted() && !personalInfo.isActive()) {
      templateConfig = markReadOnly(templateConfig);
      templateData.disableSaveProfile = true;
    }
  }

  function markReadOnly(templateConfig) {
    var config, _markReadOnly;

    config = EG.Users.Utils.deepCloneObject(config);

    _markReadOnly = function (config) {
      _.each(config, function (value, key) {
        if (_.isObject(value)) {
          _markReadOnly(value, config);
        } else {
          if (config.enabled) {
            config.readonly = true;
          }
        }
      });
    };

    _markReadOnly(config);
    return config;
  }

  function canSaveProfile(config, isSaveDisabled) {
    var _canSave;

    _canSave = function (_config) {
      _.each(_config, function (value, key) {
        if (_.isObject(value) && value.enabled) {
          _canSave(value);
        } else {
          if (!isSaveDisabled || _config.readonly == false || (_config.enabled && _config.readonly != true)) {
            isSaveDisabled = false;
            return;
          }
        }
      });
    };

    _canSave(config);

    return isSaveDisabled;
  }

  function parsePhones(phoneData) {
    var phones, parsedPhones;

    phones = EG.Users.Utils.deepCloneObject(phoneData);
    parsedPhones = {};

    _.each(phones, function (phoneObj) {
      var phoneType;

      phoneType = EG.Users.Utils.getPhoneType(phoneObj.type_code);

      parsedPhones[phoneType] = phoneObj;
    });

    return parsedPhones;
  }

  function initPhonePlugin($phones) {
    $phones.each(function () {
      var $field, countryIso2;

      $field = $(this);
      countryIso2 = EG.Users.Utils.getPOSCountryIso2();

      EG.Users.Profile.Presenters.PhoneView.initPhonePlugin({
        inputField: $field,
        country: countryIso2,
      });

      $field.closest(EG.Users.Constants.INTL_TEL_INPUT_CLASS).addClass('input-group');
    });
  }

  function updateValidation(personalInfo) {
    let isGGUUpdating = EG.Users.Utils.isGlobalGuestUserType(personalInfo.attributes.type) && EG.Users.Utils.isLoggedInUser(personalInfo.attributes.user_id);
    if (isGGUUpdating) {
      personalInfo.validation.date_of_birth.push({
        ageValidation: EG.Users.Profile.Constants.GGU_MIN_AGE_LIMIT,
        msg: "global_guest_user_age_limit",
        customVal: EG.Users.Profile.Constants.GGU_MIN_AGE_LIMIT
      });
    }
  }

  EG.Users.Profile.View.Utils.PersonalInfo = {};
  EG.Users.Profile.View.Utils.PersonalInfo.parsePersonalInfo = parsePersonalInfo;
  EG.Users.Profile.View.Utils.PersonalInfo.markReadOnly = markReadOnly;
  EG.Users.Profile.View.Utils.PersonalInfo.canSaveProfile = canSaveProfile;
  EG.Users.Profile.View.Utils.PersonalInfo.parsePhones = parsePhones;
  EG.Users.Profile.View.Utils.PersonalInfo.initPhonePlugin = initPhonePlugin;
  EG.Users.Profile.View.Utils.PersonalInfo.updateValidation = updateValidation;

})(Backbone, EG, jQuery);
